import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterMasakatsu extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday1'>
      <div><Link to='/'>Home</Link></div>
      <h3>MASAKATSU RENBUKAN DOJO's MEMBERS</h3>
      <br />
      <br />

      <div><Link to='/conduct-pawanratc'>1. AAT  7731  MS.PAWANRAT  CHUPINIJSAK(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-maytapornc'>2. AAT  7732  MS.MAYTAPORN CHUPINIJSAK(A)</Link></div>
      <br />
      <div><Link to='/conduct-jasona'>3. AAT  8053  MR.HUA YIK ANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-narat'>4. AAT  8033  MS.NARA  TAKIGUCHI(A)</Link></div>
      <br />
      <div><Link to='/conduct-cheiax'>5. AAT  8034  MR.CHAY XAVIER(A)</Link></div>
      <br />
      <div><Link to='/conduct-ornranatp'>6. AAT  8035  MS.ORNRANAT  PINTASIRI(A)</Link></div>
      <br />
      <div><Link to='/conduct-eugenea'>7. AAT  8099  MR.EUGENE ANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-wiyadaj'>8. AAT  8100  MS.WIYADA JONRAKSA(A)</Link></div>
      <br />
      <div><Link to='/conduct-thanasons'>9. AAT  8103  MS.THANASON SAMRANRUEN(A)</Link></div>
      <br />
      <div><Link to='/conduct-naphatradaq'>10. AAT  8105  MS.NAPHATRADA QIN(A)</Link></div>
      <br />
      <div><Link to='/conduct-sathawathak'>11. AAT  8106  MR.SATHAWATHA KLAYKLUNG(A)</Link></div>
      <br />
      <div><Link to='/conduct-chayaphatk'>12. AAT  8107  MS.CHAYAPHAT KLAYKLUNG(A)</Link></div>
      <br />

        <div>
          Thailand's Aikido Association Registration and Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterMasakatsu;
